<template>
  <MapWidget
    class="worst-addresses-widget"
    :title="$t('message.dashboard.widgetTitle.worstGmbAddresses')"
    :tooltip="$t('message.dashboard.widgetTooltip.worstGmbAddresses')"
    :marker-type="markerType"
    :data="data"
    :action-handler="actionHandler"
    :loading="loading"
  >
    <template v-slot="item">
      <div class="rating-row" v-if="item.reviews_rating !== null">
        <StarsRating :rating="item.reviews_rating" />

        <div class="rating-value">
          {{ item.reviews_rating.toString().replace(".", ",") }}
        </div>
        <ui-button
          transparent
          small
          class="ml-auto"
          :to="{
            name: 'reviews-list',
            query: { ids: `${item.gmb_address_id}` }
          }"
          @click.native="handleClick(item.gmb_address_id)"
        >
          {{ $t("message.common.more") }}
        </ui-button>
      </div>
    </template>
  </MapWidget>
</template>

<script>
import MapWidget from "@/components/Dashboard/base/MapWidget";
import StarsRating from "@/components/ui/StarsRating";

import { numberedSecondary } from "@/config/marker";
import { dashboardWidget } from "@/helpers/mixins/dashboard-widget";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "DashboardWorstAddressesWidget",
  components: {
    MapWidget,
    StarsRating
  },
  mixins: [dashboardWidget],
  data() {
    return {
      markerType: numberedSecondary
    };
  },
  methods: {
    handleClick(id) {
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.DASHBOARD_SHOW_DETAILS,
        component: "lowest_rated_locations",
        location_id: id
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.rating-row {
  display: flex;
  flex-direction: row;
  align-items: center;

  .rating-value {
    display: flex;
    align-items: center;
    height: 100%;
    margin-left: $spacing;
    padding-top: 3px;
  }
}
</style>

<style lang="scss">
.worst-addresses-widget {
  .map-widget-marker {
    color: $dashboard-negative-color !important;
  }

  .v-list .v-list-item .list-item-index {
    border-color: $dashboard-negative-color;
    color: $dashboard-negative-color;
  }
}

.v-btn:not(.v-btn--round).v-size--small {
  height: 26px;
}
</style>
